export default "__VITE_ASSET__a035237b__"